import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import IconMi from 'components/common/icon/IconMi';
import { getNodeWithParentByUid } from 'app/app/editor/page/getNodeByUid';
import insertNodeIntoPage from 'app/app/editor/page/insertNodeIntoPage';
import { processPageContainersUid } from 'app/app/editor/page';

export default function MenuAddContainer({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    return (
        <MenuItem
            onClick={() => {
                const node = getNodeWithParentByUid(ctx.page.layout, openWithUid);
                if (node || openWithUid == 'page') {
                    let parent = ctx.page.layout;
                    if (node) {
                        parent = node.node.type == 'container' ? node.node : node.parentNode;
                    }

                    let newPage = insertNodeIntoPage(
                        ctx.page,
                        { type: 'container', params: { uid: parent.params.uid + '-0__mark' } },
                        parent.params.uid,
                        openWithUid,
                    );
                    processPageContainersUid(newPage.layout, 'container');
                    ctx.setPage(newPage, false);
                    ctx.sendMessage({ name: 'reloadPage' });
                }
                handleClose();
            }}
        >
            <Box sx={styles.iconHolder}>
                <IconMi icon={'tiles-large'} />
            </Box>
            <Box>{t('node_context_menu.add_container')}</Box>
        </MenuItem>
    );
}
